import { FacebookTracker } from './facebook';
import { GoogleTracker } from './google';
import { GtmTracker } from './gtm';
import { KakaoTracker } from './kakao';
import { NaverTracker } from './naver';
import { InsiderTracker } from './insider';
import { TrackerEvent } from './tracker-event';
import { TrackerType } from './tracker-type';

const trackers = [];

/**
 * 등록된 모든 트래커들에게 이벤트를 송신
 * @param event {TrackerEvent|string} 이벤트 유형
 * @param data {*} 추가 정보
 */

export const track = (event, data) => {
  const act = (tracker) => {
    try {
      tracker.track(event, data);
    } catch (err) {
      console.error(err);
    }
  };

  for (const tracker of trackers) {
    if (data && data.include) {
      if (Array.isArray(data.include) && data.include.includes(tracker.name)) act(tracker);
    } else if (data && data.exclude) {
      if (Array.isArray(data.exclude) && !data.exclude.includes(tracker.name)) act(tracker);
    } else {
      act(tracker);
    }
  }
};

export const TRACKER_CLASS_MAP = {
  [TrackerType.GOOGLE]: GoogleTracker,
  [TrackerType.GTM]: GtmTracker,
  [TrackerType.FACEBOOK]: FacebookTracker,
  [TrackerType.KAKAO]: KakaoTracker,
  [TrackerType.NAVER]: NaverTracker,
  [TrackerType.INSIDER]: InsiderTracker,
};

export const register = ({ Tracker, config, context, options }) => {
  if (trackers.some((tracker) => tracker instanceof Tracker)) return;
  if (config && config.id) {
    trackers.push(new Tracker({ ...config, ...options }, context));
  }
};

export const setTrackerVariableToGivenContext = (context) => {
  context.$fc = context.$fc || {};
  context.$fc.track = track;
};
